import React from "react";
import { titleAndAria } from "protocol-setup/constants/errorMessages";
import { useRelatedRequest } from "protocol-setup/redux/useLovs";
import { FarClone } from "assets/icons";

const ViewOtherFormButton = ({ formPartType, protocolNumber, lpo, item, disabled }) => {
  const otherFormType =
    formPartType === "OPEN_RAVE" ? "REGULATORY" : "OPEN_RAVE";

  const { relatedRequest } = useRelatedRequest(
    protocolNumber,
    lpo,
    otherFormType
  );

  const handleViewOtherForm = () => {
    if (relatedRequest) {
      const url =
        otherFormType === "OPEN_RAVE"
          ? `/protocol-setup/open-rave/${relatedRequest.requestNumber}?viewOnly=true`
          : `/protocol-setup/regulatory/${relatedRequest.requestNumber}?viewOnly=true`;
      window.open(url, "_blank");
    }
  };

  if (!relatedRequest) {
    return null;
  }
  
  return (
    <div className="summary-bar">
      <button
        type="button"
        className="btn ml-1 summary-bar-item"
        onClick={handleViewOtherForm}
        disabled={disabled}
        title={titleAndAria.viewLatestPart(
          otherFormType === "OPEN_RAVE" ? "OPEN/Rave" : "Regulatory",
          relatedRequest.requestNumber
        )}
      >
        <span className="summary-bar-value">
          View {otherFormType === "OPEN_RAVE" ? "OPEN/Rave" : "Regulatory"}
        </span>
        <span className="summary-bar-key">
          <FarClone className="mr-0" />
        </span>
      </button>
    </div>
  );
};

export default ViewOtherFormButton;
